import { Services } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

import selectorSendername from '@/components/selector/sendername'
import sticker from '@/components/sticker'

function renderSenderNameField(h) {
  return h(
    selectorSendername,
    {
      props: {
        value: this.proxy.sendername,
        label: this.getTranslate(`${Services.sendernames}.labels.name`),
        itemsDisabled: this.disabledNames,
        itemValue: 'name',
        dense: true,
        clearable: true,
        required: !this.proxy.sendername,
        setRequiredOnMounted: false
      },
      on: {
        input: event => {
          this.proxy.sendername = event
        }
      }
    }
  )
}
function renderAdvertiserId(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.advertiserId,
        label: this.getTranslate(`${Services.providers}.labels.senderNameToIds.advertiserId`),
        details: false,
        dense: true,
        required: true,
        clearable: true
      },
      on: {
        input: event => {
          this.proxy.advertiserId = event
        }
      }
    }
  )
}
function renderSenderNumberID(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.senderNumberId,
        label: this.getTranslate(`${Services.providers}.labels.senderNameToIds.senderNumberId`),
        details: false,
        dense: true,
        required: true,
        clearable: true
      },
      on: {
        input: event => {
          this.proxy.senderNumberId = event
        }
      }
    }
  )
}

function renderActivator(h) {
  return h(
    sticker,
    {
      props: this.activatorProps,
      slot: 'activator'
    }
  )
}
function renderContent(h) {
  return h(
    components.list,
    {
      class: 'grid grid-gap--8 pt-3 pb-2 px-2',
      props: {
        dense: true,
        rounded: true
      }
    },
    [
      renderSenderNameField.call(this, h),
      renderAdvertiserId.call(this, h),
      renderSenderNumberID.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    components.menu,
    {
      props: {
        rounded: true,
        sameWidth: true,
        offsetDistance: 8,
        closeOnContentClick: false
      }
    },
    [
      renderActivator.call(this, h),
      renderContent.call(this, h)
    ]
  )
}
